import { useOutletContext } from "react-router-dom";
import Contact from "../components/landing/Contact";
import Events from "../components/landing/Events";
import BookingForm from "../components/landing/BookingForm";

export default function VisitPage() {
  const content = useOutletContext();
  const activeEvents = content.events.filter((e) => e.active);
  return (
    <>
      <Contact settings={content.settings} />
      {activeEvents.length > 0 && <Events events={activeEvents} />}
      <BookingForm services={content.services} settings={content.settings} />
    </>
  );
}
